import _ from 'lodash';
import Vue from 'vue';
import { api } from '@/resources/utils/api';

import Modal from '@/shared/constants/modal';
import Employees from '@/resources/constants/employees';
import Employee from '@/resources/models/employees';

import App from '@/views/constants/app';

const state = {
  employees: [],

  employeesErrors: [],
  isEmployeesLoading: {
    LOAD_ALL: false,
    LOAD: false,
    CREATE: false,
    UPDATE: false
  }
};

const getters = {
  employees: state => state.employees,
  participatingEmployees: state => state.employees.filter(e => e.participations.some(p => p.isActive)),
  activeEmployees: state => state.employees.filter(e => e.isActive && e.participations.some(p => p.isActive)),

  employeesErrors: state => state.employeesErrors,

  isEmployeesLoading: state => state.isEmployeesLoading.LOAD_ALL,
  isEmployeeLoading: state => state.isEmployeesLoading.LOAD,
  isCreateEmployeeLoading: state => state.isEmployeesLoading.CREATE,
  isUpdateEmployeeLoading: state => state.isEmployeesLoading.UPDATE
};

const actions = {
  [Employees.Actions.LoadAll.START] ({ commit, dispatch, rootGetters }, payload) {
    commit(Employees.Mutations.IsLoading.SET, { type: 'LOAD_ALL', value: true });

    if (payload == null) {
      payload = rootGetters.selectedEmployer.id;
    }

    api.get(
      encodeURI(Employees.Endpoints.LoadAll(payload)))
      .then((response) => {
        dispatch(Employees.Actions.LoadAll.SUCCESS, response.data);
      })
      .catch((errors) => {
        // dispatch(Employees.Actions.LoadAll.FAILED, errors);
      })
      .finally(() => {
        commit(Employees.Mutations.IsLoading.SET, { type: 'LOAD_ALL', value: false });
      });
  },

  [Employees.Actions.LoadAll.SUCCESS] ({ commit, getters }, payload) {
    commit(Employees.Mutations.SET, _.map(payload, data => new Employee(data)));
  },

  [Employees.Actions.Load.START] ({ commit }, data) {
    api.get(
      encodeURI(Employees.Endpoints.Load(data.employerId, data.employeeId)))
      .then((response) => {
        // dispatch(Employees.Actions.Load.SUCCESS, response.data);
        commit(Employees.Mutations.UPSERT, new Employee(response.data));
      });
  },

  [Employees.Actions.Create.START] ({ commit, dispatch }, data) {
    const endpoint = encodeURI(Employees.Endpoints.Create(data.employerId));
    commit(Employees.Mutations.IsLoading.SET, { type: 'CREATE', value: true });

    api.post(endpoint, {
      initials: data.employee.initials,
      middleName: data.employee.middleName,
      lastName: data.employee.lastName,
      middleNamePartner: data.employee.middleNamePartner,
      lastNamePartner: data.employee.lastNamePartner,
      isoDateOfDeath: data.employee.dateOfDeath,
      isoDateOfBirth: data.employee.dateOfBirth,
      gender: data.employee.gender,

      employmentIsoDate: data.relationship.fromDate,
      outOfEmploymentIsoDate: data.relationship.untilDate,
      employeeNumber: data.relationship.employeeNumber,
      grossAnnualSalary: data.detail.grossAnnualSalary.replace(',', '.'),
      professionClassification: data.detail.professionClassification,
      natureOfEmployment: data.detail.natureOfEmployment,
      noRisk: data.detail.noRisk
    })
      .then(() => {
        dispatch(Employees.Actions.Create.SUCCESS);
      })
      .finally(() => {
        commit(Employees.Mutations.IsLoading.SET, { type: 'CREATE', value: false });
      });
  },

  [Employees.Actions.Update.START] ({ commit, dispatch }, data) {
    commit(Employees.Mutations.IsLoading.SET, { type: 'UPDATE', value: true });

    const endpoint = encodeURI(Employees.Endpoints.Update(data.employerId, data.employee.id));

    const requestData = {
      gender: data.employee.gender,
      isoDateOfBirth: data.employee.dateOfBirth,
      initials: data.employee.initials,
      middleName: data.employee.middleName,
      lastName: data.employee.lastName,
      middleNamePartner: data.employee.middleNamePartner,
      lastNamePartner: data.employee.lastNamePartner,
      isoDateOfDeath: data.employee.dateOfDeath
    };

    api.put(endpoint, requestData)
      .then((response) => {
        Vue.toasted.success(`Persoonsgegevens zijn succesvol gewijzigd`, {
          icon: 'done'
        });

        dispatch(Employees.Actions.Load.START, {
          employeeId: data.employee.id,
          employerId: data.employerId
        });

        dispatch(Modal.Actions.CLOSE);
      })
      .finally(() => {
        commit(Employees.Mutations.IsLoading.SET, { type: 'UPDATE', value: false });
      });
  }
};

const mutations = {
  [Employees.Mutations.SET] (state, payload) {
    state.employees = payload;
  },

  [Employees.Mutations.UPSERT] (state, payload) {
    const index = _.findIndex(state.employees, { id: payload.id });
    Vue.set(state.employees, index, payload);
  },

  [Employees.Mutations.IsLoading.SET] (state, payload) {
    state.isEmployeesLoading[payload.type] = payload.value;
  },

  [Employees.Mutations.IsLoading.CLEAR] (state) {
    state.isEmployeesLoading = {
      LOAD_ALL: false,
      LOAD: false,
      CREATE: false,
      UPDATE: false
    };
  },

  [Employees.Mutations.Errors.SET] (state, payload) {
    state.employeesErrors = payload;
  },

  [Employees.Mutations.Errors.CLEAR] (state) {
    state.employeesErrors = [];
  },

  [App.Mutations.CLEAR] (state) {
    state.employees = [];

    state.employeesErrors = [];
    state.isEmployeesLoading = {
      LOAD_ALL: false,
      LOAD: false,
      CREATE: false,
      UPDATE: false
    };
  }
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
